import { render, staticRenderFns } from "./AutoCompletePatients.vue?vue&type=template&id=5aa6842a&"
import script from "./AutoCompletePatients.vue?vue&type=script&lang=js&"
export * from "./AutoCompletePatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports